import { Prefix } from "components/GraphTable/Prefix";
import { SearchInput } from "components/antd";
import { useCallback } from "react";

export const RequestSearch: React.FC<{
  onInputChange: (value: string | null) => void;
  searchQuery: string | null;
}> = ({ onInputChange, searchQuery }) => {
  const onChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const value = e.target.value;
      onInputChange(value === "" ? null : value);
    },
    [onInputChange]
  );
  return (
    <Prefix prefix="Search">
      <SearchInput
        value={searchQuery ?? ""}
        onChange={onChange}
        placeholder={"Enter search terms..."}
        style={{
          marginBottom: "unset",
          flexGrow: 1,
        }}
      />
    </Prefix>
  );
};
